<template>
  <DashboardLayout :breadcrumbs="breadcrumbs">
    <div class="container is-fluid">
      <h1 class="title is-5">{{ $t('routes.createResourceCategory') }}</h1>
      <div class="form-container">
        <ResourceCategoryForm @save="save"></ResourceCategoryForm>
      </div>
    </div>
  </DashboardLayout>
</template>

<script>
  import DashboardLayout from '@/components/DashboardLayout'
  import ResourceCategoryForm from "@/components/ResourceCategoryForm"

  export default {
    components: {
      ResourceCategoryForm,
      DashboardLayout,
    },
    methods: {
      save(payload) {
        this.$store.dispatch('Moderator/create', {actionType: 'resource_categories', payload}).then(() =>
          this.$router.push({ name: 'resourceCategories'}))
      }
    },
    mounted() {
      this.$store.dispatch('Moderator/getRelations', {actionType: 'resource_categories'})
    },
    computed: {
      breadcrumbs() {
        return [
          {name: 'resourceCategories', path: 'resourceCategories'},
          {name: 'createResourceCategory'}
        ]
      }
    }
  }
</script>